<template>
  <MyOrdersSingleOrderCard v-bind="data" :date="data.nextDrawDate">
    <template #header>
      <MyOrdersSingleOrderStatus :status="data.status" />
    </template>
  </MyOrdersSingleOrderCard>
</template>

<script lang="ts" setup>
import type { ActivePlaySlipOrder } from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersSingleOrderCardProps = { data: ActivePlaySlipOrder }

defineProps<MyOrdersSingleOrderCardProps>()
</script>
